import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight, Phone } from 'lucide-react';

const PompesAChaleurPage = () => {
  return (
    <div className="PompesAChaleurPage bg-white">
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center py-24"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1564164494009-3876b2d197f1)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#2D9A68]/95 to-[#2F5BA0]/85"></div>
        <div className="relative container mx-auto px-4">
          <div className="max-w-3xl text-white">
            <p className="text-lg mb-3 font-semibold opacity-90">🔥 Chauffage & Climatisation</p>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Pompes à Chaleur</h1>
            <p className="text-xl md:text-2xl mb-6">Solutions écologiques et économiques pour votre confort toute l'année</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="bg-[#2F5BA0] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#1e3a66] transition-all inline-flex items-center justify-center gap-2"
              >
                Nous contacter
              </Link>
              <a
                href="tel:0188617508"
                className="bg-white text-[#2D9A68] px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all inline-flex items-center justify-center gap-2"
              >
                <Phone size={20} />
                01 88 61 75 08
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Bannière Aides PAC 2025 */}
      <section className="py-12 bg-gradient-to-r from-[#E6A835] via-[#d49520] to-[#E6A835]">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto text-center text-white">
            <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-2 rounded-full text-sm font-bold mb-4 animate-pulse">
              🔥 NOUVEAU - Arrêté Septembre 2025
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-4">
              Aides Exceptionnelles pour les Pompes à Chaleur
            </h2>
            <p className="text-xl md:text-2xl mb-6 font-semibold">
              Jusqu'à <span className="text-5xl font-black">15 990€</span> d'aides cumulées
            </p>
            <p className="text-lg">
              MaPrimeRénov' 5 000€ + Prime CEE 10 990€ pour une PAC Air-Eau
            </p>
          </div>
        </div>
      </section>

      {/* Quelle PAC choisir */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">Quelle PAC choisir ?</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <a 
                href="#pac-air-eau" 
                className="bg-gradient-to-br from-[#E6A835] to-[#d49520] p-8 rounded-xl shadow-lg text-white hover:shadow-2xl transition-all cursor-pointer transform hover:scale-105"
              >
                <h3 className="text-2xl font-bold mb-3">🔥 PAC Air-Eau</h3>
                <p className="mb-3 text-lg">Chauffage central + eau chaude sanitaire</p>
                <p className="text-sm opacity-90">✅ Aides jusqu'à 15 990€</p>
                <p className="text-sm opacity-90">✅ Compatible radiateurs & plancher chauffant</p>
                <p className="text-sm opacity-90">✅ Idéal pour remplacer chaudière fioul/gaz</p>
              </a>
              <a 
                href="#pac-air-air" 
                className="bg-white p-8 rounded-xl shadow-md border-2 border-gray-200 hover:shadow-xl hover:border-[#2D9A68] transition-all cursor-pointer transform hover:scale-105"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3">❄️ PAC Air-Air</h3>
                <p className="text-gray-700 mb-3 text-lg">Chauffage + climatisation réversible</p>
                <p className="text-sm text-gray-600">✅ Aides CEE jusqu'à 834€</p>
                <p className="text-sm text-gray-600">✅ Installation rapide (1 journée)</p>
                <p className="text-sm text-gray-600">✅ Idéal pour remplacer convecteurs électriques</p>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* PAC AIR-EAU */}
      <section id="pac-air-eau" className="py-16 bg-white scroll-mt-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Titre */}
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Pompe à Chaleur Air-Eau</h2>
              <p className="text-xl text-gray-600">🔥 NOUVEAU 2025 : Aides renforcées - Arrêté de Septembre 2025</p>
            </div>

            {/* Aides */}
            <div className="bg-gradient-to-r from-[#E6A835] via-[#d49520] to-[#E6A835] text-white rounded-2xl p-10 text-center mb-12 shadow-xl">
              <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-2 rounded-full text-sm font-bold mb-4">
                💰 Aides Disponibles
              </div>
              <h3 className="text-2xl md:text-3xl font-bold mb-3">
                Aides Exceptionnelles pour les Pompes à Chaleur Air-Eau
              </h3>
              <p className="text-xl mb-3 font-semibold">
                Jusqu'à <span className="text-5xl font-black">15 990€</span> d'aides cumulées
              </p>
              <p className="text-lg opacity-90">
                MaPrimeRénov' 5 000€ + CEE 10 990€
              </p>
            </div>

            {/* Images */}
            <div className="grid md:grid-cols-3 gap-6 mb-12">
              {[
                'https://www.md-ouest.com/wp-content/uploads/2021/05/schema-fonctionement-PAC-Air-Eau.jpg',
                'https://www.thermor-pro.fr/var/thermor_pro/storage/images/_aliases/large/4/9/2/5/65294-1-fre-FR/539846be907a-PAC_air-eau_Aerolia_MH_UE.jpg',
                'https://le-de.cdn-website.com/af83e03199924ecebbd38a2a12fcf0a8/dms3rep/multi/opt/AdobeStock_257915850-1920w.jpeg',
              ].map((img, index) => (
                <div key={index} className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all bg-white flex items-center justify-center" style={{minHeight: '300px'}}>
                  <img 
                    src={img} 
                    alt={`PAC Air-Eau - ${index + 1}`}
                    className="w-full h-auto max-h-96 object-contain p-4"
                  />
                </div>
              ))}
            </div>

            {/* Qu'est-ce que */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Qu'est-ce qu'une pompe à chaleur air-eau ?</h3>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                La pompe à chaleur air-eau (PAC air-eau) est un système de chauffage central qui puise l'énergie thermique contenue dans l'air extérieur pour chauffer l'eau circulant dans vos radiateurs, planchers chauffants ou ventilo-convecteurs. Cette technologie permet de diviser votre facture de chauffage par 3 à 4 par rapport à une chaudière traditionnelle au fioul, gaz ou électrique.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                Écologique et performante, la PAC air-eau fonctionne même par températures négatives jusqu'à -20°C grâce aux modèles récents. Elle peut également produire votre eau chaude sanitaire, remplaçant ainsi complètement votre ancienne chaudière.
              </p>
            </div>

            {/* Comment ça fonctionne */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Comment fonctionne une pompe à chaleur air-eau ?</h3>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                Le fonctionnement repose sur un cycle thermodynamique en 4 étapes :
              </p>
              <ol className="list-decimal list-inside space-y-3 text-gray-700 mb-4 text-lg ml-4">
                <li><strong>Captation :</strong> L'unité extérieure capte les calories présentes dans l'air extérieur grâce à un évaporateur.</li>
                <li><strong>Compression :</strong> Un compresseur élève la température du fluide frigorigène qui s'est évaporé.</li>
                <li><strong>Condensation :</strong> Le fluide cède sa chaleur à l'eau du circuit de chauffage via un condenseur.</li>
                <li><strong>Détente :</strong> Le fluide refroidi retourne vers l'évaporateur pour un nouveau cycle.</li>
              </ol>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                Ce cycle se répète en continu pour maintenir la température souhaitée dans votre logement. L'installation comprend une unité extérieure (qui contient le compresseur et l'évaporateur) et une unité intérieure (module hydraulique) raccordée à votre circuit de chauffage existant.
              </p>
            </div>

            {/* Avantages et Inconvénients */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Avantages & Inconvénients</h3>
              <div className="grid md:grid-cols-2 gap-8">
                {/* Avantages */}
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">✅ Avantages</h3>
                  <div className="space-y-4">
                    {[
                      '🔥 Aides renforcées 2025 : jusqu\'à 15 990€',
                      '💰 Jusqu\'à 70% d\'économies sur factures',
                      '🎁 Bonus sortie fioul/gaz : +1 000€',
                      '♻️ Émissions CO₂ divisées par 14',
                      '❄️ Fonctionne jusqu\'à -20°C',
                      '🏠 Compatible radiateurs existants',
                      '🔇 Silencieux (< 50 dB)',
                    ].map((benefit, index) => (
                      <div key={index} className="flex items-start gap-3">
                        <Check className="text-[#2D9A68] mt-1 flex-shrink-0" size={20} />
                        <span className="text-gray-700">{benefit}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Inconvénients */}
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">⚠️ Inconvénients</h3>
                  <div className="space-y-4">
                    {[
                      '⚠️ Nécessite un circuit d\'eau existant',
                      '🔧 Vérifier compatibilité radiateurs',
                      '💶 Investissement initial important',
                      '📏 Nécessite espace extérieur pour unité',
                      '🛠️ Installation complexe (2-3 jours)',
                      '🔍 Entretien annuel obligatoire',
                      '❄️ Performance réduite < -15°C',
                    ].map((inconvenient, index) => (
                      <div key={index} className="flex items-start gap-3">
                        <span className="text-red-500 mt-1 flex-shrink-0">✕</span>
                        <span className="text-gray-700">{inconvenient}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Pour quels logements */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Pour quel type de logement ?</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 text-lg">
                <li><strong>Maisons individuelles</strong> neuves ou en rénovation de 80 à 250 m² et plus</li>
                <li><strong>Compatible avec votre installation existante :</strong> radiateurs fonte ou aluminium, plancher chauffant basse température, ventilo-convecteurs</li>
                <li><strong>Idéale pour remplacer une chaudière fioul ou gaz</strong> (utilise le circuit d'eau existant, pas de gros travaux)</li>
                <li><strong>Adaptée aux logements BBC et RT 2012</strong> grâce à ses hautes performances</li>
                <li>Note : Pour remplacer un chauffage électrique (convecteurs), privilégier une PAC Air-Air plus simple à installer</li>
              </ul>
            </div>

            {/* Caractéristiques techniques */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Caractéristiques Techniques</h3>
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <ul className="space-y-4">
                  {[
                    'Puissance : 8 à 16 kW selon surface et isolation',
                    'COP moyen : 3,5 à 4,5 (pour 1 kW consommé → 4 kW restitués)',
                    'Classe énergétique : A+++ (très haute performance)',
                    'Température de fonctionnement : -20°C à +40°C',
                    'Niveau sonore extérieur : 45 à 50 dB',
                    'Durée de vie : 15 à 20 ans',
                    'Garantie constructeur : 5 ans pièces et main d\'œuvre',
                    'Entretien obligatoire : 1 visite annuelle',
                  ].map((spec, index) => (
                    <li key={index} className="flex items-start gap-3 text-lg">
                      <Check className="text-[#2F5BA0] mt-1 flex-shrink-0" size={20} />
                      <span className="text-gray-700">{spec}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Séparateur */}
      <div className="border-t-4 border-gray-200"></div>

      {/* PAC AIR-AIR */}
      <section id="pac-air-air" className="py-16 bg-gray-50 scroll-mt-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Titre */}
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Pompe à Chaleur Air-Air</h2>
              <p className="text-xl text-gray-600">Chauffage et climatisation réversible - Aides 2025</p>
            </div>

            {/* Aides */}
            <div className="bg-gradient-to-r from-[#2D9A68] to-[#2F5BA0] text-white rounded-2xl p-8 text-center mb-12 shadow-lg">
              <p className="text-lg mb-2 opacity-90">💰 Aides disponibles</p>
              <p className="text-3xl md:text-4xl font-bold">Jusqu'à 834€ (CEE - Éligible MaPrimeRénov' parcours global uniquement)</p>
            </div>

            {/* Images */}
            <div className="grid md:grid-cols-3 gap-6 mb-12">
              {[
                'https://particuliers.engie.fr/content/dam/nouvel-univer-ee/pages-produit/schema-pac-air-air.svg',
                'https://www.thermor.fr/var/site/storage/images/_aliases/optimized/8/9/2/8/9238298-1-fre-FR/bbbe87e87ae7-schema-fonctionnement-pompe-a-chaleur-air-air-mode-froid.jpg',
                'https://static-www.cozynergy.com/climatisation-pompe-chaleu-air-air.jpg',
              ].map((img, index) => (
                <div key={index} className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all bg-white flex items-center justify-center" style={{minHeight: '300px'}}>
                  <img 
                    src={img} 
                    alt={`PAC Air-Air - ${index + 1}`}
                    className="w-full h-auto max-h-96 object-contain p-4"
                  />
                </div>
              ))}
            </div>

            {/* Qu'est-ce que */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Qu'est-ce qu'une pompe à chaleur air-air ?</h3>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                La pompe à chaleur air-air est un système de climatisation réversible qui diffuse directement de l'air chaud ou froid dans vos pièces via des unités intérieures murales (appelées splits). Contrairement à la PAC air-eau, elle ne nécessite aucun circuit d'eau, ce qui rend son installation beaucoup plus simple et rapide.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                Idéale pour remplacer des convecteurs électriques énergivores, la PAC air-air permet de diviser votre facture de chauffage par 3 tout en ajoutant la fonction climatisation pour l'été. C'est la solution parfaite pour un confort toute l'année sans gros travaux.
              </p>
            </div>

            {/* Comment ça fonctionne */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Comment fonctionne une PAC air-air ?</h3>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                Le principe est simple : une unité extérieure capte les calories de l'air ambiant et les transfère à une ou plusieurs unités intérieures qui diffusent l'air traité dans vos pièces. Le système peut être mono-split (1 unité intérieure) ou multi-split (jusqu'à 5 unités pour couvrir plusieurs pièces).
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed text-lg">
                En mode chauffage, la PAC extrait la chaleur de l'air extérieur et la diffuse à l'intérieur. En mode climatisation, elle inverse simplement le cycle : elle extrait la chaleur de votre intérieur et la rejette à l'extérieur. La technologie Inverter ajuste en permanence la puissance pour optimiser votre confort et vos économies.
              </p>
            </div>

            {/* Avantages et Inconvénients */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Avantages & Inconvénients</h3>
              <div className="grid md:grid-cols-2 gap-8">
                {/* Avantages */}
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">✅ Avantages</h3>
                  <div className="space-y-4">
                    {[
                      '❄️ Réversible : Chauffage + Climatisation',
                      '⚡ Installation rapide (1 journée)',
                      '💰 Divisez par 3 votre facture électrique',
                      '🔥 Aides CEE (jusqu\'à 834€)',
                      '📱 Contrôle intelligent via smartphone',
                      '🌡️ Technologie Inverter haute performance',
                      '🔇 Ultra-silencieuse (19-22 dB)',
                      '🌀 Filtration de l\'air intégrée',
                    ].map((benefit, index) => (
                      <div key={index} className="flex items-start gap-3">
                        <Check className="text-[#2D9A68] mt-1 flex-shrink-0" size={20} />
                        <span className="text-gray-700">{benefit}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Inconvénients */}
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">⚠️ Inconvénients</h3>
                  <div className="space-y-4">
                    {[
                      '💶 Aides limitées (pas MaPrimeRénov\')',
                      '🚫 Pas de production eau chaude',
                      '📦 Une unité intérieure par pièce',
                      '🔧 Entretien annuel obligatoire',
                      '💨 Peut assécher l\'air en hiver',
                      '❄️ Performance réduite < -10°C',
                    ].map((inconvenient, index) => (
                      <div key={index} className="flex items-start gap-3">
                        <span className="text-red-500 mt-1 flex-shrink-0">✕</span>
                        <span className="text-gray-700">{inconvenient}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Pour quels logements */}
            <div className="prose prose-lg max-w-none mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Pour quel type de logement ?</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-700 mb-4 text-lg">
                <li><strong>Maisons et appartements</strong> de 30 à 150 m²</li>
                <li><strong>Idéale pour remplacer des convecteurs électriques</strong> (grille-pains) énergivores</li>
                <li><strong>Parfaite en complément d'un chauffage existant</strong> pour les mi-saisons</li>
                <li><strong>Solution climatisation + chauffage</strong> en un seul équipement</li>
                <li><strong>Logements sans circuit de chauffage central</strong> (pas de radiateurs à eau)</li>
                <li>Multi-split pour couvrir plusieurs pièces avec une seule unité extérieure</li>
              </ul>
            </div>

            {/* Caractéristiques techniques */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Caractéristiques Techniques</h3>
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <ul className="space-y-4">
                  {[
                    'Puissance : 2,5 à 5 kW par unité intérieure',
                    'COP chaud : 4 à 5 (4 kW de chaleur pour 1 kW consommé)',
                    'EER froid : 3,5 à 4,5 (performance climatisation)',
                    'Mono-split ou Multi-split (jusqu\'à 5 unités intérieures)',
                    'Température de fonctionnement : -15°C à +46°C',
                    'Niveau sonore intérieur : 19 à 22 dB (silence)',
                    'Classe énergétique : A++ à A+++',
                    'Garantie : 3 à 5 ans constructeur',
                  ].map((spec, index) => (
                    <li key={index} className="flex items-start gap-3 text-lg">
                      <Check className="text-[#2F5BA0] mt-1 flex-shrink-0" size={20} />
                      <span className="text-gray-700">{spec}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-16 bg-gradient-to-r from-[#2D9A68] to-[#2F5BA0] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Intéressé par une pompe à chaleur ?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Nos experts certifiés QualiPAC et Qualibat sont à votre disposition
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/test-eligibilite"
              className="bg-[#E6A835] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#d49520] transition-all inline-flex items-center justify-center gap-2"
            >
              Testez votre éligibilité <ArrowRight />
            </Link>
            <Link
              to="/contact"
              className="bg-white text-[#2D9A68] px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all inline-flex items-center justify-center gap-2"
            >
              Demander un devis gratuit
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PompesAChaleurPage;
